import { environment } from '@y42/environment';
import JSON_SCHEMA_DEFINITION_VERSION_JSON from '@y42/json-schema/package.json';

type FeatureJSONSchemaDefinition = Readonly<
  Array<{
    name: string;
  }>
>;

const CORE_SCHEMA_DEFINITION = [
  {
    name: 'y42-metadata',
  },
] as const;

const INTEGRATION_SCHEMA_DEFINITION = [
  {
    name: 'integration-settings',
  },
  {
    name: 'integration-table-settings',
  },
] as const;

const MODELING_SCHEMA_DEFINITION = [
  {
    name: 'ui-modeling-settings',
  },
  {
    name: 'ui-modeling-table-settings',
  },
  {
    name: 'sql-modeling-settings',
  },
  {
    name: 'sql-modeling-table-settings',
  },
] as const;

const VISUALIZATION_SCHEMA_DEFINITION = [
  {
    name: 'visualization-dashboard-settings',
  },
  {
    name: 'visualization-canvas-element',
  },
  {
    name: 'visualization-theme-settings',
  },
  {
    name: 'visualization-widget-settings',
  },
  {
    name: 'visualization-filter-settings',
  },
] as const;

const LINEAGE_SCHEMA_DEFINITION = [
  {
    name: 'lineage-settings',
  },
] as const;

const ORCHESTRATION_SCHEMA_DEFINITION = [
  {
    name: 'orchestration-settings',
  },
] as const;

const EXPORT_SCHEMA_DEFINITION = [
  {
    name: 'export-settings',
  },
  {
    name: 'export-trigger-settings',
  },
] as const;

const ALERT_SCHEMA_DEFINITION = [
  {
    name: 'status-alert-settings',
  },
] as const;

const DATA_TEST_SCHEMA_DEFINITION = [
  {
    name: 'data-test-settings',
  },
] as const;

const JSON_SCHEMA_DEFINITIONS = [
  { folder: 'core', models: CORE_SCHEMA_DEFINITION },
  { folder: 'integration', models: INTEGRATION_SCHEMA_DEFINITION },
  { folder: 'models', models: MODELING_SCHEMA_DEFINITION },
  { folder: 'lineage', models: LINEAGE_SCHEMA_DEFINITION },
  { folder: 'visualization', models: VISUALIZATION_SCHEMA_DEFINITION },
  { folder: 'orchestration', models: ORCHESTRATION_SCHEMA_DEFINITION },
  { folder: 'export', models: EXPORT_SCHEMA_DEFINITION },
  { folder: 'alert', models: ALERT_SCHEMA_DEFINITION },
  { folder: 'data-test', models: DATA_TEST_SCHEMA_DEFINITION },
];

const __JSON_SCHEMA_DEFINITIONS__TYPE_CHECK: Array<{ folder: string; models: FeatureJSONSchemaDefinition }> =
  JSON_SCHEMA_DEFINITIONS;

export type JSON_SCHEMA_DEFINITION_KEY = (typeof JSON_SCHEMA_DEFINITIONS)[number]['models'][number]['name'];

export const FEATURE_JSON_SCHEMA_MAP = new Map<
  JSON_SCHEMA_DEFINITION_KEY,
  {
    name: string;
    folder: string;
  }
>();

export function getJSONSchemaURL(key: JSON_SCHEMA_DEFINITION_KEY, version?: string): string {
  const jsonSchemaDefinition = FEATURE_JSON_SCHEMA_MAP.get(key);

  if (!jsonSchemaDefinition) {
    throw new Error('Schema definition not found');
  }

  const { name, folder } = jsonSchemaDefinition;
  version = version || JSON_SCHEMA_DEFINITION_VERSION_JSON?.version || 'latest';

  return `${environment.url.json_schema}/frontend/${version}/${folder}/${name}.json`;
}

JSON_SCHEMA_DEFINITIONS.map(({ folder, models }) => models.map((model) => ({ ...model, folder })))
  .flat()
  .forEach((definition) => {
    FEATURE_JSON_SCHEMA_MAP.set(definition.name, definition);
  });

export const METADATA_JSON_SCHEMA_URL = getJSONSchemaURL('y42-metadata');
